// extracted by mini-css-extract-plugin
export var list = "ContactGP-module--list--0f18a";